/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import Vuex from 'vuex';
import axios, { AxiosError, AxiosResponse } from 'axios';
import router from '@/router';
import api, { api2, apiSandbox, apiProduction } from '@/libs/api';
import { RefreshTokenResponse } from '@/libs/api.interfaces';
import { RootState } from './types';
import toast from './toast';
import disbursement from './disbursement';
import disbursementManagement from './disbursementManagement';
import recon from './recon';

Vue.use(Vuex);

const store = new Vuex.Store<RootState>({
  state: {
    sidebarUpdatedId: 0,
    sidebarCollapsed: false,
    loggedIn: false,
    user: null,
    timeoutCounter: 10,
    timeoutDefault: 2400,
    doubleLogin: false,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    collapse(state) {
      state.sidebarCollapsed = true;
    },
    expand(state) {
      state.sidebarCollapsed = false;
    },
    setLoggedIn(state, value: boolean) {
      state.loggedIn = value;
    },
    setUser(state, value) {
      state.user = value;
    },
    updateSidebar(state) {
      state.sidebarUpdatedId += 1;
    },
    setTimeout(state, value: number) {
      state.timeoutCounter = value;
    },
    doubleLogin(state, value: boolean) {
      state.doubleLogin = value;
    },
  },
  actions: {},
  modules: {
    toast,
    disbursement,
    disbursementManagement,
    recon,
  },
});

const refreshToken = async (token: string) => {
  try {
    const uuid = Vue.$cookies.get('browser_uuid');
    const reference = Vue.$cookies.get('reference_token');
    if (!uuid) {
      window.location.href = `${process.env.VUE_APP_PRODUCTION_DOMAIN}/login`;
    }
    const { data } = await api.post<RefreshTokenResponse>('/refresh-token', {
      // eslint-disable-next-line @typescript-eslint/camelcase
      refresh_token: token,
      // eslint-disable-next-line @typescript-eslint/camelcase
      reference_token: reference === 'null' ? null : reference,
    }, {
      headers: { 'x-browser-id': uuid },
    });
    if (reference) {
      Vue.$cookies.remove('reference_token', '/', window.location.hostname);
    }
    return data.data;
  } catch (err) {
    return null;
  }
};

const redirectException = [
  '/login',
  '/reset-user',
  '/forgot-password',
  '/change-password',
  '/twofa',
  '/verify-twofa',
];

const CheckApiStatusCode = (resp: AxiosResponse<any>, isApi2: boolean) => {
  const Arr = [401, 402];
  if (
    isApi2
    && resp.status === 403
  ) {
    Arr.push(403);
  }
  if (resp.status === 401) {
    /* tslint:disable:no-empty */
    try {
      const hasErrors = resp.data.error;
      if (hasErrors.errors[0]?.message === 'doublelogin') {
        store.commit('doubleLogin', true);
        return false;
      }
    } catch (err) {
      console.log();
    }
  }
  console.log('response', resp);
  return Arr.includes(resp.status);
};

const ErrorHandler = (error: any, isApi2: boolean) => new Promise((resolve, reject) => {
  const err = error as AxiosError;
  if (
    err.response
    && (CheckApiStatusCode(err.response, isApi2))
    && redirectException.find((e) => err.response?.config.url?.includes(e)) === undefined
  ) {
    const user = localStorage.getItem('USER');
    const rfCookie = Vue.$cookies.get('refresh_token');
    if (rfCookie !== null) {
      refreshToken(rfCookie).then((newToken: any) => {
        if (newToken !== null) {
          const newUser = {
            ...store.state.user,
            ...newToken,
          };

          localStorage.setItem('USER', JSON.stringify(newUser));
          store.commit('setUser', newUser);
          err.config.headers.token = `${isApi2 ? 'Bearer ' : ''}${newToken.token}`;
          api.defaults.headers.common.token = newToken.token;
          apiSandbox.defaults.headers.common.token = newToken.token;
          apiProduction.defaults.headers.common.token = newToken.token;
          api2.defaults.headers.common.token = `Bearer ${newToken.token}`;
          resolve(axios.request(err.config));
        }
      }).catch((a: any) => {
        console.log(a);
        reject(a);
      });
      // const newToken = await refreshToken(rfCookie);
      // if (newToken !== null) {
      //   const newUser = {
      //     ...store.state.user,
      //     ...newToken,
      //   };
      //   localStorage.setItem('USER', JSON.stringify(newUser));
      //   store.commit('setUser', newUser);
      //   err.config.headers.token = `${isApi2 ? 'Bearer ' : ''}${newToken.token}`;
      //   api.defaults.headers.common.token = newToken.token;
      //   api2.defaults.headers.common.token = `Bearer ${newToken.token}`;
      //   return axios.request(err.config);
      // }
    } else if (store.state.user !== null) {
      refreshToken(store.state.user.refresh_token).then((newToken: any) => {
        if (newToken !== null) {
          const newUser = {
            ...store.state.user,
            ...newToken,
          };

          localStorage.setItem('USER', JSON.stringify(newUser));
          store.commit('setUser', newUser);
          err.config.headers.token = `${isApi2 ? 'Bearer ' : ''}${newToken.token}`;
          api.defaults.headers.common.token = newToken.token;
          apiSandbox.defaults.headers.common.token = newToken.token;
          apiProduction.defaults.headers.common.token = newToken.token;
          api2.defaults.headers.common.token = `Bearer ${newToken.token}`;
          resolve(axios.request(err.config));
        } else {
          localStorage.clear();
          api.defaults.headers.common.token = undefined;
          apiSandbox.defaults.headers.common.token = undefined;
          apiProduction.defaults.headers.common.token = undefined;
          api2.defaults.headers.common.token = undefined;
          store.commit('setLoggedIn', false);
          store.commit('setUser', null);
          router.push('/login');
          reject('error while refresh token'); // eslint-disable-line
        }
      });
    } else if (user !== null) {
      try {
        const refreshTokenls = JSON.parse(user).refresh_token;
        refreshToken(refreshTokenls).then((newToken: any) => {
          if (newToken !== null) {
            const newUser = {
              ...store.state.user,
              ...newToken,
            };

            localStorage.setItem('USER', JSON.stringify(newUser));
            store.commit('setUser', newUser);
            err.config.headers.token = `${isApi2 ? 'Bearer ' : ''}${newToken.token}`;
            api.defaults.headers.common.token = newToken.token;
            apiSandbox.defaults.headers.common.token = newToken.token;
            apiProduction.defaults.headers.common.token = newToken.token;
            api2.defaults.headers.common.token = `Bearer ${newToken.token}`;
            resolve(axios.request(err.config));
          } else {
            localStorage.clear();
            api.defaults.headers.common.token = undefined;
            apiSandbox.defaults.headers.common.token = undefined;
            apiProduction.defaults.headers.common.token = undefined;
            api2.defaults.headers.common.token = undefined;
            store.commit('setLoggedIn', false);
            store.commit('setUser', null);
            router.push('/login');
            reject('error while refresh token'); // eslint-disable-line
          }
        });
      } catch (errs) {
        localStorage.clear();
        api.defaults.headers.common.token = undefined;
        apiSandbox.defaults.headers.common.token = undefined;
        apiProduction.defaults.headers.common.token = undefined;
        api2.defaults.headers.common.token = undefined;
        store.commit('setLoggedIn', false);
        store.commit('setUser', null);
        router.push('/login');
        reject('error while refresh token'); // eslint-disable-line
      }
    }
  } else {
    reject(error);
  }
});

api.interceptors.response.use(
  (response) => response,
  (error) => ErrorHandler(error, false),
);

api2.interceptors.response.use(
  (response) => response,
  (error) => ErrorHandler(error, true),
);

apiSandbox.interceptors.response.use(
  (response) => response,
  (error) => ErrorHandler(error, false),
);

apiProduction.interceptors.response.use(
  (response) => response,
  (error) => ErrorHandler(error, false),
);

api.interceptors.request.use(
  async (config) => {
    store.commit('setTimeout', store.state.timeoutDefault);
    return config;
  },
);

api2.interceptors.request.use(
  async (config) => {
    store.commit('setTimeout', store.state.timeoutDefault);
    return config;
  },
);

apiSandbox.interceptors.request.use(
  async (config) => {
    store.commit('setTimeout', store.state.timeoutDefault);
    return config;
  },
);

apiProduction.interceptors.request.use(
  async (config) => {
    store.commit('setTimeout', store.state.timeoutDefault);
    return config;
  },
);
export default store;
